import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/standard/use-case-1.png'
import _imports_1 from '../assets/img/standard/use-case-2.png'
import _imports_2 from '../assets/img/standard/use-case-3.png'
import _imports_3 from '../assets/img/standard/use-case-4.png'
import _imports_4 from '../assets/img/standard/share-city.png'
import _imports_5 from '../assets/img/standard/share-1.png'
import _imports_6 from '../assets/img/standard/share-2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-63ef8dc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "textbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-text1" }, "远程异地评标和评标专家库共享技术标准"),
    /*#__PURE__*/_createElementVNode("div", { class: "banner-text2" }, " 助力建设全国统一大市场，优化市场营商环境 ")
  ])
], -1))
const _hoisted_2 = { class: "gray" }
const _hoisted_3 = { class: "gray" }
const _hoisted_4 = { class: "use-case" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_8 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_9 = { style: {"margin-left":"20px"} }
const _hoisted_10 = { class: "principle-main" }
const _hoisted_11 = { class: "share-ideas" }
const _hoisted_12 = { class: "card-main" }
const _hoisted_13 = { class: "idea-title" }
const _hoisted_14 = {
  key: 0,
  src: _imports_4,
  alt: ""
}
const _hoisted_15 = {
  key: 1,
  src: _imports_5,
  alt: ""
}
const _hoisted_16 = {
  key: 2,
  src: _imports_6,
  alt: ""
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "gray" }
const _hoisted_19 = { class: "list-main" }
const _hoisted_20 = { class: "list-main" }
const _hoisted_21 = { class: "list-main" }

import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import mytitle from '../components/title.vue'
import Description from '../components/standard/description/index'
import StandardCard from '../components/standard/standard-card'
import { getStandard, downloadWithFilePath, documentPreview, endpointDownload } from '../utils/axios'

/**
 * 背景、目的、范围
 */
// 使用范围

export default /*#__PURE__*/_defineComponent({
  __name: 'standard',
  setup(__props) {

const useCase = ref(['场所工位互联', '专家库互联', '远程异地评标', '远程实时监督'])

// 编制背景
const handleBg = () => {
  window.open('https://www.gov.cn/xinwen/2022-03/13/content_5678833.htm', '_blank')
}

// 编制目的
const handleObjective = () => {
  window.open('https://www.gov.cn/gongbao/content/2022/content_5687499.htm', '_blank')
}

// 使用范围
const handleRange = () => {
  // TODO
}

// 共享思路
const shareIdeas = ref([
  {
    title: '技术层面',
    ideas: [
      {
        title: '基于移动CA并兼容硬件CA锁',
        desc: `采用<b style='color:#323335'>移动CA数字证书</b>，无需硬件底层驱动，避免硬件介质环境兼容和驱动升级所带来的各种问题。同时<b style='color:#323335'>兼容现有硬件CA锁</b>，不影响现有存量硬件CA锁使用。`,
      },
      {
        title: '目录共享和“点对点”互联',
        desc: `建立覆盖各类系统的全国<b style='color:#323335'>移动CA数字证书互认共享清单目录</b>，各电子招标投标交易平台应在本侧部署符合本标准规范的CA互认共享组件，<b style='color:#323335'>通过网络实现应用间“点对点”联通，高效共享。</b>`,
      },
    ]
  },
  {
    title: '管理层面',
    ideas: [
      {
        title: '增设“互认入口”',
        desc: `在保留各省级区域内电子招标投标交易平台的“原统一入口”使用现状基础上，增加<b style='color:#323335'>“全国共享互认CA入口”</b>，实现各省级区域内交易平台上办理的移动CA数字证书<b style='color:#323335'>跨省级区域、跨系统异地共享使用</b>`,
      },
      {
        title: '增加按时按量付费模式',
        desc: `经营主体首次通过某省级区域内“原统一入口”在当地系统上办理移动CA数字证书后，跨省在异地系统使用时，可以<b style='color:#323335'>自主选择按天、按次付费或其他付费方式</b>，无需异地重复办理，大大降低使用成本`,
      },
    ]
  }
])

/**
 * 编制原则
 */
// 编制原则展示数据
const principles = ref([
  {
    title: '坚持以经营主体为中心',
    desc: `坚持从经营主体需求出发，按照 “方便快捷 在线办理”  “降本增效 兼容中立”为原则，实现“一处办理证书、处处互认可用”，切实减轻经营主体负担、降低经营主体交易成本，增强经营主体的获得感，落实经营主体的自主选择权`,
  },
  {
    title: '坚持兼容中立开放原则',
    desc: `按照“谁付费谁选择”的原则，移动数字证书（CA）互认技术标准能够充分兼容各类平台技术路线和CA数字证书应用现状、符合各类主体在各类业务场景的应用需要，切实提升电子交易全流程的交易效率和服务水平`,
  },
  {
    title: '坚守安全合规底线',
    desc: `严格执行密码行业以及数据安全等方面的法律法规要求，结合招标投标实际，确保 “依法依规，安全可靠”`,
  },
  {
    title: '坚持全国范围共享方向',
    desc: `站在建设全国统一大市场的高度，立足全国互认共享站位，打破平台、地区和行业壁垒，切实实现主体CA数字证书全国范围内跨平台、跨区域、跨行业兼容互认`,
  },
  {
    title: '强化电子招标投标交易平台的主体责任',
    desc: `电子招标投标交易平台应依据本标准规范自主选择CA互认APP、互认CA机构、互认印章机构，落实电子招标投标交易平台的主体责任，更好地为招标投标项目服务，为经营主体服务`,
  },
])

// 控制编制原则向左向右移动
const showPrinciple = ref([0, 1, 2])

// 点击右箭头按钮
const handleRight = () => {
  const lastIndex = showPrinciple.value[2]
  if (lastIndex === principles.value.length - 1) {
    return
  }
  showPrinciple.value = [lastIndex - 1, lastIndex, lastIndex + 1]
}

// 点击左箭头按钮
const handleLeft = () => {
  const firstIndex = showPrinciple.value[0]
  if (firstIndex === 0) {
    return
  }
  showPrinciple.value = [firstIndex - 1, firstIndex, firstIndex + 1]
}

/**
 * 技术标准
 */
// 技术标准展示数据
const standards = ref([
  {
    title: '移动数字证书(CA)互认服务规范',
    standardType: 1,
    type: '服务规范',
    desc: {
      title: '面向各类平台、系统的运营方，在<span>服务内容及使用流程</span>',
      texts: [
        '规定移动数字证书（CA）的标准术语和定义',
        '基本原则与要求',
        '总体架构和总体流程',
        '服务内容',
      ]
    }
  },
  {
    title: '移动数字证书(CA)互认技术规范',
    standardType: 3,
    type: '技术规范',

    desc: {
      title: '面向各类平台、系统的开发方，在<span>技术路线和功能实现</span>',
      texts: [
        '规定互认CA证书技术要求',
        '规定交易平台/工具和公共服务、平台的技术路线、功能要求和接口格式',
        '规定CA机构、印章机构和APP的技术路线、功能要求和接口格式',
      ]
    }
  },
  {
    title: '移动数字证书(CA)互认数据规范',
    type: '数据规范',

    standardType: 2,
    desc: {
      title: '面向跨应用共享数据方，在<span>数据交互</span>',
      texts: [
        '规定了交易系统/交易工具、CA认证机构、印章机构、APP互联对接实现CA证书办理、共享使用的数据需求',
        '规定交易平台/规定实名认证、证书办理、证书漫游、电子签章等数据收集',
      ]
    }
  },
])

// 技术标准接口数据
const standardList = ref([])

onMounted(() => {
  getStandard().then(res => {
    standardList.value = res.data
  })
})

// 1服务 2数据 3技术
const findfile = (type) => {
  let url = ''
  standardList.value.map(item => {
    if (item.standardType == type) {
      url = item.standardFile
    }
  })
  return url
}

// 预览
const handlePreview = (item) => {
  const url2 = findfile(item.standardType)
  if (url2) {


    window._czc.push(['_trackEvent', '互认标准', '预览', item.type + '预览'])
    window.open(url2, '_blank')

  } else {
    ElMessage.warning('功能开发中，敬请期待！')
  }
}

// 下载
const handleDownload = (item) => {
  window._czc.push(['_trackEvent', '互认标准', '下载', item.type + '下载'])
  let url2 = findfile(item.standardType)
  if (url2) {
    const url = new URL(url2)
    let path = String(url.pathname)
    downloadWithFilePath({ contentDisposition: 'attachment', filePath: path }).then(res => {
      var blob = new Blob([res])
      let fname = item.title + '.pdf'; //下载文件的名字
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fname);
      } else {
        let objectUrl = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = objectUrl;
        link.setAttribute("download", fname);
        document.body.appendChild(link);
        link.click();
      }
    })
  } else {
    ElMessage.warning('功能开发中，敬请期待！')
  }
}

/**
 * 接入指南
 */
// 接入指南
const guides = ref([
  { title: '移动数字证书(CA)互认交易平台接入指南', type: 8, name: '移动数字证书(CA)互认交易平台接入指南' },
  { title: '移动数字证书(CA)互认APP接入指南', type: 7, name: '移动数字证书(CA)互认APP接入指南' },
  { title: '移动数字证书(CA)互认CA机构接入指南', type: 5, name: '移动数字证书(CA)互认CA机构接入指南' },
  { title: '移动数字证书(CA)互认印章机构接入指南', type: 6, name: '移动数字证书(CA)互认印章机构接入指南' },
  { title: '移动数字证书(CA)互认签章验签组件接入指南', type: 10, name: '移动数字证书（CA）互认技术标准签章组件接入指南' },


  { title: '移动数字证书(CA)互认加密组件接入指南', type: 11, name: '移动数字证书(CA)互认技术标准加密组件接入指南' },

  { title: '移动数字证书(CA)互认解密组件接入指南', type: 12, name: '移动数字证书(CA)互认技术标准解密组件接入指南' },



])



// 接入指南
const guides2 = ref([
  { title: '交易中心与CA互认共享组件合作协议', type: 13, name: '交易中心与CA互认共享组件合作协议' },
  { title: '电子招标投标交易系统交易工具运营机构与CA互认APP运营机构协议', type: 14, name: '电子招标投标交易系统交易工具运营机构与CA互认APP运营机构协议' },
  // { title: 'CA机构进驻CA互认APP协议', type: 15, name: 'CA机构进驻CA互认APP协议' },
  // { title: '印章机构进驻CA互认APP协议', type: 16, name: '印章机构进驻CA互认APP协议' },
  
])

// 预览 友盟统计
const previewGuide = (item) => {
  documentPreview({ documentType: item.type }).then(res => {


    if (item.type == 8) {
      window._czc.push(['_trackEvent', '互认交易平台', '预览', '交易平台接入指南预览'])
    }
    if (item.type == 7) {
      window._czc.push(['_trackEvent', '互认APP', '预览', 'APP接入指南预览'])
    }
    if (item.type == 6) {
      window._czc.push(['_trackEvent', '互认印章机构', '预览', '印章机构接入指南预览'])
    }
    if (item.type == 5) {
      window._czc.push(['_trackEvent', '互认CA机构', '预览', 'CA机构接入指南预览'])
    }



    window.open(res.data.documentUrl, '_blank');
  }).catch(res => {
    ElMessage.warning('功能开发中，敬请期待！')
  })

}
// 下载 友盟统计
const downloadGuide = (item) => {

  if (item.type == 8) {
    window._czc.push(['_trackEvent', '互认交易平台', '下载', '交易平台接入指南下载'])
  }
  if (item.type == 7) {
    window._czc.push(['_trackEvent', '互认APP', '下载', 'APP接入指南下载'])
  }
  if (item.type == 6) {
    window._czc.push(['_trackEvent', '互认印章机构', '下载', '印章机构接入指南下载'])
  }
  if (item.type == 5) {
    window._czc.push(['_trackEvent', '互认CA机构', '下载', 'CA机构接入指南下载'])
  }



  let name2 = ''
  documentPreview({ documentType: item.type }).then(res => {
    name2 = res.data.documentName


    endpointDownload({ documentType: item.type }).then(res => {
      var blob = new Blob([res])
      let fname = name2 + '.pdf'; //下载文件的名字
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fname);
      } else {
        let objectUrl = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = objectUrl;
        link.setAttribute("download", fname);
        document.body.appendChild(link);
        link.click();
      }


    }).catch(res => {

    })

  }).catch(res => {
    ElMessage.warning('功能开发中，敬请期待！')
  })


}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("main", null, [
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "编制背景" }),
        _createVNode(_unref(Description), {
          title: "推进全流程电子化 标准化 数字化",
          showbtn: true,
          content: [
          '2022年3月5日，《关于2021年国民经济和社会发展计划执行情况与2022年国民经济和社会发展计划草案的报告》中明确提出“推动完善招标投标法律法规和制度规则，全面推行招标投标全流程电子化，编制电子招标投标技术标准和数据规范”。',
          '2022年3月29日，中国招标投标协会组织召开电子招标投标全流程技术标准编制工作部署会，移动数字证书（CA）作为首批八大技术标准之一，也是其他技术标准的基础。'
        ],
          onDetail: handleBg
        })
      ]),
      _createElementVNode("section", _hoisted_2, [
        _createVNode(mytitle, { title: "编制目的" }),
        _createVNode(_unref(Description), {
          type: "objective",
          direction: "right",
          showbtn: true,
          title: "提升交易效率 优化营商环境 推进全国统一大市场",
          content: [
          '贯彻落实《中共中央国务院关于加强全国统一大市场的意见》文件精神，紧扣全流程电子化要求，建立全国统一开放、中性兼容、接轨融合的网络共享CA的公共基础性技术标准，规范CA数字证书办理、促进CA数字证书跨区域共享应用，推进电子采购交易全流程向纵深发展，提升交易效率。',

        ],
          onDetail: handleObjective
        })
      ]),
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "适用范围" }),
        _createVNode(_unref(Description), {
          type: "range",
          title: "推进网络互联共享评标专家库",
          showbtn: false,
          content: [
          '本标准适用于提供电子招标、投标领域实现CA数字证书全国范围内跨区域、跨平台网络共享的各类电子招标采购交易系统/交易工具、公共服务平台、监督平台、CA机构、印章机构、互认APP等。',
          '本标准也适用于电子非招标采购领域。各地区、各平台开发本平台CA应用可参照执行。'
        ],
          onDetail: handleRange
        })
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(mytitle, { title: "使用场景" }),
        _createElementVNode("main", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useCase.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : _createCommentVNode("", true),
                (index === 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : _createCommentVNode("", true),
                (index === 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true),
                (index === 3)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_9, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "编制原则" }),
        _createElementVNode("main", _hoisted_10, [
          _withDirectives(_createElementVNode("div", {
            class: "arrow arrow-left",
            onClick: handleLeft
          }, null, 512), [
            [_vShow, showPrinciple.value[0] !== 0]
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(principles.value, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                key: index,
                class: "principle-item"
              }, [
                _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", null, _toDisplayString(item.desc), 1)
              ], 512)), [
                [_vShow, showPrinciple.value.includes(index)]
              ])
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "arrow arrow-right",
            onClick: handleRight
          }, null, 512), [
            [_vShow, showPrinciple.value[2] !== principles.value.length - 1]
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "共享思路" }),
        _createElementVNode("main", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareIdeas.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "share-card",
              key: index
            }, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ideas, (idea, idI) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "idea-item",
                    key: idI
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      (idI === 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : (index === 0)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                          : (index === 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                            : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(idea.title), 1)
                    ]),
                    _createElementVNode("p", {
                      innerHTML: idea.desc
                    }, null, 8, _hoisted_17)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createVNode(mytitle, { title: "技术标准" }),
        _createElementVNode("main", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(standards.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(StandardCard), {
              key: index,
              title: item.title,
              desc: item.desc,
              onPreview: ($event: any) => (handlePreview(item)),
              onDownload: ($event: any) => (handleDownload(item))
            }, null, 8, ["title", "desc", "onPreview", "onDownload"]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "接入指南" }),
        _createElementVNode("main", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guides.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(StandardCard), {
              key: index,
              title: item.title,
              onPreview: ($event: any) => (previewGuide(item)),
              onDownload: ($event: any) => (downloadGuide(item))
            }, null, 8, ["title", "onPreview", "onDownload"]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "协议模板" }),
        _createElementVNode("main", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guides2.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(StandardCard), {
              key: index,
              title: item.title,
              onPreview: ($event: any) => (previewGuide(item)),
              onDownload: ($event: any) => (downloadGuide(item))
            }, null, 8, ["title", "onPreview", "onDownload"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})